<template>
<div>
  <div class="wistia_embed wistia_async_exmgnsdl9h">
    &nbsp;
  </div>

  <div
    id="choose_administrator"
    class="tbk-vid-embed"
  >
    <a
      id="keys_cecilia"
      class="embedded_video"
      href="#wistia_xc6uvuwz47?videoFoam=true"
    >
      &nbsp;
    </a>
    <br>

    <a
      id="keys_fatuma"
      class="embedded_video"
      href="#wistia_xen35ypir4?videoFoam=true"
    >
      &nbsp;
    </a>
    <br>

    <a
      id="keys_julia"
      class="embedded_video"
      href="#wistia_wndil9jhgo?videoFoam=true"
    >
      &nbsp;
    </a>
    <br>

    <a
      id="keys_patina"
      class="embedded_video"
      href="#wistia_z71kmi08mp?videoFoam=true"
    >
      &nbsp;
    </a>
    <br>
  </div>
</div>
</template>

<script>
import TbkVideoMixin from './TbkVideoMixin'

export default {
  mixins: [TbkVideoMixin],

  mounted() {
    this.tbk.loadCrossTime('exm', 0, this.showSelect)

    this.tbk.loadCrossTime('xc6', 99, this.showSelect)
    this.tbk.loadCrossTime('xen', 143, this.showSelect)
    this.tbk.loadCrossTime('wnd', 65, this.showSelect)
    this.tbk.loadCrossTime('z71k', 117, this.showSelect)

    if (this.tbk.isMobile()) {
      _wq.push({
        xc6: this.tbk.autoPlay,
        xen: this.tbk.autoPlay,
        wnd: this.tbk.autoPlay,
        z71k: this.tbk.autoPlay
      })
    }
  },

  methods: {
    showSelect() {
      $('.tbk-vid-embed').show()
      this.tbk.hideMobileControls()
    }
  }
}
</script>

<style scoped lang="sass">
#choose_administrator
  display: none
  a
    text-decoration: none
#keys_cecilia
  position: absolute
  top: 0
  left: 0
  width: 25%
  height: 100%
#keys_fatuma
  position: absolute
  top: 0
  left: 25%
  width: 25%
  height: 100%
#keys_julia
  position: absolute
  top: 0
  left: 50%
  width: 25%
  height: 100%
#keys_patina
  position: absolute
  top: 0
  left: 75%
  width: 25%
  height: 100%
</style>
